import { render, staticRenderFns } from "./free-response-generic.vue?vue&type=template&id=ea966a86&"
import script from "./free-response-generic.vue?vue&type=script&lang=js&"
export * from "./free-response-generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports